import axiosInstance from "./AxiosInstance";

// List questions
export function listQuestions(payload) {
  return axiosInstance.post("/admin/QuestionList", payload);
}

// Add a new question
export function addQuestion(payload) {
  return axiosInstance.post("/admin/addQuestion", payload);
}

// Edit an existing question
export function editQuestion(payload) {
  return axiosInstance.post("/admin/editQuestion", payload);
}

// Delete a question
export function deleteQuestion(payload) {
  return axiosInstance.post("/admin/deleteQuestion", payload);
}
